<!-- 招生系统基础配置 -- 中考普高控制线 -- 编辑 -->
<template>
	<edit-template class="form" @confirm="submit" @cancel="$confirm('取消新增?','提示',{type:'warning'}).then(res=>$router.back()).catch(()=>{});" :cancelRemind="false" confirmText="保存" cancelText="取消">
		
    <el-form :model="form" :rules="rules" ref="form" label-width="150rem" style="width: calc(100% - 300rem);margin-left:  22rem;margin-bottom: 100rem;min-height: calc(100vh - 412rem)">
      <el-form-item label="省份" prop="province">
        <p>{{ form.province }}</p>
      </el-form-item>
      <el-form-item label="城市" prop="city">
        <p>{{ form.city }}</p>
      </el-form-item>
      <el-form-item label="选择年份" prop="year">
        <p>{{ form.year }}</p>
      </el-form-item>

      <h4 style="padding: 50rem 0 20rem 30rem">编辑各区/县中考普高控制线</h4>

      <div class="knowledge" v-for="(item, index) in form.sub" :key="item.id">
        <div class="flex" style="background: #f4f4f4;padding: 20rem 40rem 20rem 0">
          <el-form-item label="选择区/县" label-width="100rem" style="margin-bottom: 0">
            <el-select :popper-append-to-body="true" v-model="item.area">
              <el-option v-for="item in areaOptions" :label="item.address_name" :value="item.address_code" :disabled="item.disabled">
            </el-option></el-select>
          </el-form-item>
          <el-form-item label="分数线" label-width="100rem" style="margin-bottom: 0" :prop="'sub.'+index+'.score'" :rules="[
            {pattern:/^[\w\s,，.。!！\-;；+=\'\‘“\[\]【】\(\)（）]{0,10}$/,message:'请输入10字以内的数字，符号，字母'}
          ]">
            <el-input placeholder="请输入" maxlength="10" v-model="item.score"></el-input>
          </el-form-item>
        </div>
        <div class="flex" style="margin-left: 40rem">
          <el-button icon="el-icon-delete" circle="" @click="deleteKnowledge(index)" v-if="form.sub.length !== 1"></el-button>
          <el-button icon="el-icon-plus" circle="" @click="addKnowledge"></el-button>
        </div>
      </div>
    </el-form>
    
  
</edit-template>
</template>

<script>

export default {
	_config:{"route":{"path":"edit","meta":{"title":"编辑"}}},
  data(){
    return{
      isFirst: true,
      backType: 0,
      form:{
        province: '',
        city: '',
        year: '',
        sub: [{area: '', score: ''}]
      },
      rules:{
        province:[{required:true,message:"请选择省份"}],
        city:[{required:true,message:"请选择城市"}],
        year:[{required:true,message:"请选择年份"}],
      },
      provinceOptions: [],
      cityOptions: [],
      areaOptions: [],
      yearList: []
    }
  },
  created() {
    this.getData()
  },
  watch:{
    form:{
      deep: true,
      handler(val){
        let arr = val.sub.map(item => item.area)
        this.areaOptions.forEach(item => {
          item.disabled = arr.includes(item.address_code)
        })
      }
    }
  },
  methods:{
    getData(){
      this.$_register('/api/recruit/score-line/' + this.$route.query.id).then(res => {
        this.form = res.data.data
        this.getArea(res.data.data.city_code)
        if(res.data.data.sub.length === 0){
          this.form.sub = [{area: '', score: ''}]
        }else{
          let arr = res.data.data.sub.map(item => item.area)
          this.areaOptions.forEach(item => {
            item.disabled = arr.includes(item.address_code)
          })
        }
      })
    },

    // 添加科目
    addKnowledge() {
      this.form.sub.push({area: '', score: ''})
    },

    //获取区/县
    getArea(e){
      this.$_register('/api/recruit/common/area',{params:{address_code: e}}).then(res => {
        let data = res.data.data
        this.areaOptions = data.map(item => {
          return {...item, disabled: false}
        })
      })
    },

    // 删除科目
    deleteKnowledge(index) {
      this.form.sub.splice(index, 1)
    },

    // 提交数据
    submit(){
      this.$refs.form.validate((res,e,p)=>{
        if (res){
          let params = {sub: this.form.sub}
          this.$_register.post("/api/recruit/score-line/" + this.$route.query.id ,params).then(res=>{
            this.$message({
              type: 'success',
              message: res.data.msg,
              onClose: () => {
                // this.$store.commit("setPage",1);
                // this.backType = 1
                this.$router.back();
              }
            });
          })
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.form{
  padding-top: 70rem;
}
::v-deep .el-form .el-input{
  min-width: 250rem;
}

.knowledge {
  padding-left: 60rem;
  margin-top: 24rem;
  display: flex;
  justify-content: center;
  align-items: center;
  .knowledge_box {
    display: flex;
    padding-top: 12rem;
    height: 60rem;
    background-color: #f4f4f4;
  }
  .add_knowledge {
    display: flex;
    padding-left: 40rem;
  }
}
</style>
